import type { ComponentType } from 'react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { AkeylessPathPickerField } from './AkeylessPathPickerField';

export const AkeylessPathPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AkeylessPathPicker',
    // RJSF ui:options is wider than AkeylessPathPickerUiOptions; field component validates at runtime.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: AkeylessPathPickerField as any,
  }),
) as unknown as ComponentType;
